<template>
  <div class="container-fluid py-2">
    <div class="row g-3">
      <div class="col-12">
        <!-- Modern Sticky Tabs Header -->
        <div class="contract-tabs-card card mb-3 shadow-sm">
          <div class="card-body p-2">
            <el-tabs v-model="tabIndex" class="contract-modern-tabs">
              <el-tab-pane :name="0">
                <template #label>
                  <span class="tab-label-custom">
                    <i class="bi bi-file-earmark-text me-1"></i> Müqavilə məlumatı
                  </span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="1">
                <template #label>
                  <span class="tab-label-custom">
                    <i class="bi bi-paperclip me-1"></i> Fayllar və sənədlər
                  </span>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <!-- Tab Contents -->
        <div class="card shadow-sm p-3 p-md-4">
          <Info v-if="tabIndex === 0" @toggle-nav="showNavData = !showNavData"></Info>
          <Files v-if="tabIndex === 1"></Files>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Info from './Components/Info/Main.vue';
import Files from './Components/Files/Main.vue';

export default {
  name: "ContractMain",
  components: {
    Info,
    Files
  },
  data() {
    return {
      tabIndex: 0,
      showNavData: true
    };
  }
};
</script>

<style scoped lang="scss">
.contract-tabs-card {
  border: 1px solid var(--app-border, #e2e8f0);
  border-radius: var(--app-radius, 8px);
  background: var(--app-surface, #ffffff);
}

:deep(.contract-modern-tabs) {
  .el-tabs__header {
    margin: 0;
    border-bottom: none;
  }

  .el-tabs__nav-wrap::after {
    display: none;
  }

  .el-tabs__item {
    font-size: 0.85rem;
    font-weight: 650;
    color: var(--app-text, #64748b);
    padding: 0 16px;
    height: 38px;
    line-height: 38px;
    transition: all 0.15s ease;

    &:hover {
      color: var(--bs-info, #0b4f9c);
    }

    &.is-active {
      color: var(--bs-info, #0b4f9c);
      font-weight: 750;
    }
  }

  .el-tabs__active-bar {
    background-color: var(--bs-info, #0b4f9c);
    height: 3px;
    border-radius: 3px;
  }
}

.tab-label-custom {
  display: inline-flex;
  align-items: center;
  font-size: 0.85rem;
}

[data-theme="dark"] {
  .contract-tabs-card {
    background: #182029;
    border-color: #2e3846;
  }

  :deep(.contract-modern-tabs) {
    .el-tabs__item {
      color: #94a3b8;

      &:hover {
        color: #60a5fa;
      }

      &.is-active {
        color: #93c5fd;
      }
    }

    .el-tabs__active-bar {
      background-color: #60a5fa;
    }
  }
}
</style>